import type { ACJSHost } from '../../types.tsx';
import { jiraModule } from './main.tsx';

export const registerJiraModules = (connectHost: ACJSHost) => {
	connectHost.defineModule('jira', jiraModule);
};
